import { IAPIBeneficiaryModel } from "../interfaces/IAPIBeneficiaryModel";

 
export class BeneficiaryModel {
    id: string;
    name: string;
    constructor(data?: Partial<BeneficiaryModel>) {
        this.id = (data && data.id) || '';
        this.name = (data && data.name) || '';
    }

    static deserializeAPIList(data: IAPIBeneficiaryModel[]): BeneficiaryModel[] {
        const list: BeneficiaryModel[] = [];

        if (Array.isArray(data)) {
            data.forEach((d) => {
                const mappedData = this.deserializeAPIModel(d);

                list.push(mappedData);
            });
        }
        return list;
    }

    static deserializeAPIModel(data: IAPIBeneficiaryModel): BeneficiaryModel {
        const mappedData: Partial<BeneficiaryModel> = {
            id: data.id,
            name: data.name,
        };
        return new BeneficiaryModel(mappedData);
    }
}
